import { useCallback, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import classNames from 'classnames';
import { Formik, useFormikContext } from 'formik';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { BootstrapTable } from '@components/Table/Table';
import { useThrottle } from '@features/useThrottle';

const renderFilterHeader = (formikContext, header, field) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { handleChange, handleBlur, values } = formikContext;

  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);

  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Form.Group controlId={`formGroup${header}`}>
      <Form.Label>{header}</Form.Label>
      <Form.Control
        type="input"
        name={field}
        size="sm"
        value={values[field]}
        onChange={throttledChangeHandler}
        onBlur={handleBlur}
        placeholder="Search"
      />
    </Form.Group>
  );
};

const filterIfIncludesString = (rows, id, filterValue, field) =>
  filterValue
    ? rows.filter((row) =>
        String(row.original[field])
          .toLowerCase()
          .includes(filterValue.toLowerCase())
      )
    : rows;

export const OutboundPrefixesTable = ({ data, isLoading }) => {
  const [searchParams] = useSearchParams();

  const prefix = searchParams.get('prefix');
  const country = searchParams.get('country');
  const filterData = { country, prefix };
  const columns = useMemo(
    () => [
      {
        Header: () => {
          const formikContext = useFormikContext();
          return renderFilterHeader(formikContext, 'Prefix', 'prefix');
        },
        accessor: 'prefix',
        filter: (rows, id, filterValue) =>
          filterIfIncludesString(rows, id, filterValue, 'prefix'),
      },
      {
        Header: () => {
          const formikContext = useFormikContext();
          return renderFilterHeader(formikContext, 'Country', 'country');
        },
        accessor: 'country',
        filter: (rows, id, filterValue) =>
          filterIfIncludesString(rows, id, filterValue, 'country'),
      },
      { Header: 'Destination', accessor: 'destination' },
      { Header: 'Active', accessor: 'active' },
    ],
    []
  );
  return (
    <Formik
      enableReinitialize
      initialValues={{ country: '', prefix: '' }}
      onSubmit={() => {}}
    >
      <BootstrapTable
        columns={columns}
        data={data}
        tableProps={() => ({ responsive: true, className: 'normalFontSize' })}
        rowProps={({ original }) =>
          original.active
            ? {}
            : { className: classNames('text-muted', 'bg-light') }
        }
        isLoading={isLoading}
        filterData={filterData}
        paginated
      />
    </Formik>
  );
};
